import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CardAvatar } from "../../card/CardAvatar";

const useStyles = makeStyles((theme) => ({
  profileContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),

    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(1),
      marginBottom: theme.spacing(0.5),
    },
  },

  profileName: {
    marginLeft: theme.spacing(1),
  },

  avatar: {
    width: 40,
    height: 40,
  },
}));

interface JourneyProfileInfoProps {
  profileName: string;
  profileAvatar: string;
  profileSubtitle?: string;
}

export function JourneyProfileInfo({
  profileName,
  profileAvatar,
  profileSubtitle,
}: JourneyProfileInfoProps) {
  const s = useStyles();

  return (
    <Box className={s.profileContainer}>
      <CardAvatar src={profileAvatar} className={s.avatar} />
      <Box className={s.profileName}>
        <Typography variant="subtitle1">
          {profileName}
        </Typography>
        <Typography variant="subtitle2" color="textPrimary" lineHeight={1.2} fontWeight={400}>
          {profileSubtitle}
        </Typography>
      </Box>
    </Box>
  );
}
